import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';
import { ComponentType } from "react";
import { ClickAnalyticsPlugin } from '@microsoft/applicationinsights-clickanalytics-js';
import { env } from 'shared/config/env/env';

const reactPlugin = new ReactPlugin();
// *** Add the Click Analytics plug-in. ***
const clickPluginInstance = new ClickAnalyticsPlugin();
const clickPluginConfig = {
	autoCapture: true
};
const appInsights = new ApplicationInsights({
	config: {
		connectionString: env.APPINSIGHTS_CONNECTION_STRING,
		// *** If you're adding the Click Analytics plug-in, delete the next line. ***
		extensions: [reactPlugin, clickPluginInstance],
		// *** Add the Click Analytics plug-in. ***
		// extensions: [reactPlugin, clickPluginInstance],
		extensionConfig: {
			// *** Add the Click Analytics plug-in. ***
			[clickPluginInstance.identifier]: clickPluginConfig,
		}
	}
});
appInsights.loadAppInsights();

function withAppInsights<P>(Component: ComponentType<P>) {
	return withAITracking(reactPlugin, Component)
}

export { reactPlugin, withAppInsights, appInsights };
